export const ISSUE_TYPES = {
  RECORDABLE: "Recordable",
  INTERNAL_DELAY: "InternalDelay",
  PUNCH: "Punch", // @TODO: This is still used by the mobile;
  WEATHER: "Weather",
  TASK: "Task",
};

export const ISSUE_RELATIONSHIPS = {
  BLOCKS: "Blocks",
  CAUSED_BY: "CausedBy",
  RESOLVED_BY: "ResolvedBy",
  REPORTED_ON: "ReportedOn",
};
